import $ from 'jquery'

function initTabsBlock () {
  $('.tabs').each(function () {
    const $tabs = $(this)
    const $tabButtons = $tabs.find('.tabs__nav-item__btn')
    const $tabContents = $tabs.find('.tabs-content')

    $tabButtons.on('click', function () {
      const $clickedButton = $(this)
      const target = $clickedButton.data('tab')

      if ($clickedButton.attr('aria-selected') === 'true') return

      // Update button states
      $tabButtons.attr('aria-selected', 'false').removeClass('active')
      $clickedButton.attr('aria-selected', 'true').addClass('active')

      // Update content visibility
      $tabContents.each(function () {
        const $contentItem = $(this)
        if ($contentItem.attr('data-tab') === target) {
            setTimeout(() => {
                $contentItem.attr('aria-hidden', 'false').fadeIn(300)
            }, 300);
        } else {
          $contentItem.attr('aria-hidden', 'true').fadeOut(300)
        }
      })
    })
  })
}

export { initTabsBlock }
